module.exports = __webpack_public_path__ + "img/phone.13b1ce00.svg";